import React from "react";
import { Grid } from "@chakra-ui/react";
import PathPickSearchProductsPopularLineSheetCard from "@/features/pathpick/features/search-products/components/popular/PathPickSearchProductsPopularLineSheetCard";
import { PathPickHotDealLineSheet } from "@/features/pathpick/types";

interface Props {
  items: PathPickHotDealLineSheet[];
  selectedLineSheetId: number | null;
  onSelectLineSheet: (lineSheet: PathPickHotDealLineSheet) => void;
}

function PathPickSearchProductsPopularLineSheetList({
  items,
  selectedLineSheetId,
  onSelectLineSheet,
}: Props) {
  return (
    <Grid
      templateColumns={"repeat(auto-fill, minmax(420px, 1fr))"}
      gap={"12px"}
    >
      {items.map((item) => (
        <PathPickSearchProductsPopularLineSheetCard
          key={item.id}
          item={item}
          isSelected={item.id === selectedLineSheetId}
          onSelect={() => onSelectLineSheet(item)}
        />
      ))}
    </Grid>
  );
}

export default PathPickSearchProductsPopularLineSheetList;
